import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.textQuote(0.05)};
  color: ${({ theme }) => theme.colors.textQuote()};
  padding: 15px;
  width: 100%;

  @media screen and (max-width: 576px) {
    max-width: 100%;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  line-height: 1.8;
`;

export const Separator = styled.div`
  border-bottom: solid 1px ${({ theme }) => theme.colors.textQuote(0.2)};
  margin: 8px 0;
`;
